import useColor from '@/hooks/domain/useColor';

import { getAlphaColor } from './colors/color.utils';

const useCustomAntdTheme = () => {
  const color = useColor();

  return {
    components: {
      Table: {
        cellFontSize: 12,
        headerColor: color.gray600,
        headerBg: color.gray200,
      },
      Radio: {
        buttonCheckedBg: color.primaryAlpha(0.1),
      },
      Segmented: {
        itemSelectedBg: getAlphaColor(color.gray100, 0.8),
        trackBg: color.gray400,
      },
      Select: {
        borderRadiusSM: 6,
      },
    },
    token: {
      colorTextPlaceholder: color.gray500,
      colorPrimary: color.primary100,
      colorBgBase: color.gray100,
      colorTextBase: color.gray800,
      colorBorder: color.gray400,
      colorBgContainer: color.gray100,
      colorPrimaryBg: color.ND08,
      borderRadius: 6,
      fontFamily:
        "Instrument Sans, Pretendard, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    },
  };
};

export default useCustomAntdTheme;
